<template>
   <nav aria-label="Page navigation example">
        <ul class="pagination">
            <li class="page-item" v-bind:class="{'disabled': data.prev_page_url == null}">
                <a class="page-link" @click="navigate(data.prev_page_url)">
                    Atrás
                </a>
            </li>
            <li class="page-item" v-bind:class="{'active': (item == data.current_page)}" v-for="item in pages">
                <a class="page-link" @click="navigate(data.path + `?page=${item}`)">
                    {{item}}
                </a>
            </li>
            <li class="page-item">
                <a class="page-link" @click="navigate(data.next_page_url)">
                    Siguiente
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    props: ["data"],
    data() {
        return {
            pages: []
        };
    },
    beforeUpdate() {
        let totalPages = (this.data.total / this.data.per_page).toFixed(0)
        this.pages = []
        for(let i = 1; i <= totalPages; i++) {
            this.pages.push(i)
        }
    },
    methods: {
        navigate(url) {
            axios.get(url).then((res) => {
                this.$emit('onNavigate', res.data)
            })
        }
    }
}
</script>
